import React, { useState } from "react";
import { Box, Typography } from "@material-ui/core";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  InfoWindow,
  Polyline,
} from "react-google-maps";
import polyline from "@mapbox/polyline";

// helpers
import displayName from "../helpers/displayName";

function Map(props) {
  let initialCenter = props.center;

  if (!initialCenter?.lat || !initialCenter?.lng) {
    initialCenter = { lat: 51.0438715, lng: -114.0713467 };
  }

  const [map, setMap] = useState(null);
  const [center, setCenter] = useState(initialCenter);
  const [isOpen, setIsOpen] = useState(false);

  React.useEffect(() => {
    if (props.center.lat && props.center.lng) {
      setCenter(props.center);
    }

    if (map) {
      const bounds = new window.google.maps.LatLngBounds();
      bounds.extend(new window.google.maps.LatLng(center.lat, center.lng));

      if (!!props.riderPosition.lat && !!props.riderPosition.lng) {
        bounds.extend(
          new window.google.maps.LatLng(
            props.riderPosition.lat,
            props.riderPosition.lng
          )
        );
      }
      if (!!props.storePosition.lat && !!props.storePosition.lng) {
        bounds.extend(
          new window.google.maps.LatLng(
            props.storePosition.lat,
            props.storePosition.lng
          )
        );
      }

      map.fitBounds(bounds);
    }
  }, [center, map, props.center, props.riderPosition, props.storePosition]);

  const loadRef = (map) => setMap(map);

  const toggleInfoWindow = () => {
    setIsOpen((prevValue) => setIsOpen(!prevValue));
  };

  let pathCoordinates = [];
  if (props.route) {
    pathCoordinates = polyline
      .decode(props.route)
      .map((rt) => ({ lat: rt[0], lng: rt[1] }));
  }

  return (
    <GoogleMap
      ref={loadRef}
      defaultZoom={8}
      center={center}
      zoom={13}
      options={{ streetViewControl: false }}
    >
      {/* Draw Polylines */}
      {pathCoordinates.length > 0 && (
        <Polyline
          path={pathCoordinates}
          geodesic={true}
          options={{
            strokeColor: "#687b31",
            strokeOpacity: 1,
            strokeWeight: 3,
            icons: [
              {
                offset: "0",
                repeat: "20px",
              },
            ],
          }}
        />
      )}

      <Marker
        position={center}
        icon={{
          url: "/marker-customer.png",
          scaledSize: new window.google.maps.Size(45, 45),
        }}
      />
      {props.storePosition?.lat ? (
        <Marker
          position={props.storePosition}
          icon={{
            url: "/marker-rider.png",
            scaledSize: new window.google.maps.Size(45, 45),
          }}
        ></Marker>
      ) : null}
      {props.riderPosition?.lat ? (
        <Marker position={props.riderPosition} onClick={toggleInfoWindow}>
          {isOpen && (
            <InfoWindow onCloseClick={toggleInfoWindow}>
              <Typography component={"span"}>
                <Box display="flex" flexDirection="row">
                  <Box fontWeight="fontWeightBold">Rider:</Box>
                  <Box pl={1}>
                    {displayName(props.rider?.firstName, props.rider?.lastName)}
                  </Box>
                </Box>
                {props.rider?.mobileNumber && (
                  <Box display="flex" flexDirection="row">
                    <Box fontWeight="fontWeightBold">Mobile #:</Box>
                    <Box pl={1}>{` ${props.rider?.mobileNumber}`}</Box>
                  </Box>
                )}
              </Typography>
            </InfoWindow>
          )}
        </Marker>
      ) : null}
    </GoogleMap>
  );
}

export default withScriptjs(withGoogleMap(Map));
